import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
// import ListView from '../utils/ListView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Row, Container } from 'react-bootstrap';
import ProjEditForm from './ProjEditForm';
// import ProjCreateForm from './ProjCreateForm'
// import ProjCreateForm2 from './ProjCreateForm2'
// import Enums from '../../enums';
import queryString from 'query-string';

class ProjectsAddApp extends React.Component {
    E_TYPE = {
        ALL: 0,
        SINGLE: 1
    };

    constructor(props) {
        super(props);
        Tools.init();
        API.init(this);

        let date = new Date();

        this.state = {
            isDisabled: false,
            formData: {
                "p_type": 0,
                "name": "",
                "start_at": Tools.dateToFormatStr(date),
                "end_at": Tools.dateToFormatStr(new Date().setDate(date.getDate() + 1)),
                "max_people": 0,
                "extra_point": 0,
                "point": 0,
                "pointExtra": 0,
                "cash_point": 0,
                "max_people": 10000,
                "source": "EZC",
                "is_top": 0,
                "is_recom": 0,
                "start_page": "要認真填寫唷",
                "end_page": "快去抽大獎吧！",
                "full_page": "",
                "description": "填答時間約3分鐘，請認真填答喔！",
                "test": {
                    isAll: true,
                    isGender: false,
                    gender: "male",
                    isAge: false,
                    isAddr: false,
                },
                "tag": "",
                "empty_1": "",
                "icon": "",
                "images": [],
                "is_del": 0,
            }
        };

        let queryParse = queryString.parse(this.props.location.search);
        console.log(queryParse);
        if (null != queryParse.pid) {
            this.state.isDisabled = true;
            this.getData(queryParse.pid);
        }

        // const { register, handleSubmit, errors } = useForm();
        // const onSubmit = data => console.log(data);
        // console.log(errors);
    }

    getData(pid) {
        console.log(pid);

        API.GetProjectByID({
            ty: 1, //0=該帳號下全部專案, 1=單⼀一專案
            pi: pid
        })
            .then(response => {
                console.log(response);

                if (response && response.responseData) {
                    // if (response.responseData.code && "22000" !== response.responseData.code){
                    if (response.responseData.data) {
                        // alert(response.responseData.data);

                        let proj = response.responseData.data[0];
                        this.setState({ formData: proj });
                    }
                }
                // if (!data || !data.code || 22040 != data.code) {
                //     //error
                //     alert("請確認帳密");
                // } else {
                //     this.props.history.push(API.first_page);
                // }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error)); //head, body
    }

    onSubmit(data) {
        console.log(data);
        if (null == data) return;
        let p_typeParse = parseInt(data.p_type);
        if (isNaN(p_typeParse)) {
            alert("請選擇問卷類型");
            return;
        }

        let tmp = { ...data };

        delete tmp["empty_1"];
        //------ TODO: 處理發送對象 --------
        delete tmp["test"];

        if (tmp.interval && tmp.interval.length > 0) {
            tmp.interval = new Date(tmp.interval).getTime();
        }

        //interval type
        if (data.p_type == 2) {
            if (!data.interval_year) data.interval_year = 0;
            if (!data.interval_month) data.interval_month = 0;
            if (!data.interval_day) data.interval_day = 0;
        }

        tmp.start_at = new Date(tmp.start_at).getTime();
        tmp.end_at = new Date(tmp.end_at).getTime();

        console.log(tmp);
        API.AddProject({
            ty: 0
        }, tmp)
            .then(response => {
                console.log(response);

                try {
                    if (response && response.responseData) {
                        if (response.responseData.pid) {
                            let pidTmp = response.responseData.pid;
                            alert("新增成功, id:" + pidTmp);
                            // props.history.push('/proj/edit/' + pidTmp);
                        }
                        else if (response.responseData.msg) {
                            alert(response.responseData.msg);
                        }
                    }
                } catch (e) {
                    console.warn(e.stack);
                }
                // if (!data || !data.code || 22040 != data.code) {
                //     //error
                //     alert("請確認帳密");
                // } else {
                //     this.props.history.push(API.first_page);
                // }
            }) // JSON from `response.json()` call
            .catch(error => console.error(error)); //head, body
    }

    render() {
        // const { list, sort_type, fields } = this.state,
        //     totalEntries = list.length,
        //     onListViewClicked = this.onListViewClicked;
        return (
            <Row>
                <Col className="col-md-10 mx-auto">
                    {/* < ProjCreateForm isDisabled={this.state.isDisabled} formData={this.state.formData} onSubmit={this.onSubmit} /> */}

                    <ProjEditForm
                        formData={this.state.formData}
                        onUpdate={this.onSubmit}
                        isDisabled={false}
                        isAddProj={true} />
                    {/* < ProjCreateForm2 /> */}
                </Col>
            </Row>
        );
    }
}

// ReactDOM.render(
//     React.createElement(ProjectsAddApp),
//     document.getElementById('root')
// );

const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProjectsAddApp))